<template>
  <div class="main-container" v-if="!getIsMobile()">
    <header class="main-header" :class="[{ open: isTitlePanelOpen }]" v-show="!getIsMobile()">
      <div class="main-header-left">
        <!-- <img src="../assets/images/logo.png" alt="로고" class="main-header-logo" @click.stop="state.map.setView(defaultLocation)" /> -->
        <img src="../assets/images/unpeace_blue.svg" alt="로고" class="main-header-logo" @click.stop="state.map.setView(defaultLocation)" />
        <h1 class="main-header-title" style="padding-left: 10px;">Smart Camp</h1>
      </div>
      <div class="main-header-right">
        <UserStatusBar />
        <img src="@/assets/images/setting.svg" style="width: 30px; height: 30px; cursor: pointer;" :title="$t('menu')" @click="isMenuModalOpen = true"/>
        <!-- <img src="@/assets/images/logout.svg" style="width: 24px; height: 24px; cursor: pointer;" :title="$t('logout')" @click="logout"/> -->
      </div>
    </header>
    <!-- 토글 버튼 -->
    <div style="background-color: transparent; z-index: 500; margin-bottom: -20px;" v-show="!getIsMobile()">
      <button class="toggle-button-title" ref="toggleBtnTitle" @click="togglePanelTitle">
        <img v-if="isTitlePanelOpen" src="@/assets/images/arrow_up.svg" />
        <img v-else src="@/assets/images/arrow_down.svg" />
      </button>
    </div>

    <main class="main-body">
      <div :class="['main-body-right', { open: isRightPanelOpen }]">
        <div class="main-body-search">
          <div style="display: flex; justify-content: space-between; width: 100%;">
            <h1>필터 및 검색</h1>
          </div>
          <div class="main-body-search" style="padding: 0;" v-if="showMobileOrNB === 0">
            <h2>검색 기준</h2>
            <select v-model="searchType">
              <option v-for="type in searchTypeList" :key="type.name" :value="type.name">{{ type.title }}</option>
            </select>
            <h2>{{ searchTypeList.find(type => type.name === searchType).inputboxtag }}</h2>
            <!-- 장치ID / 장치이름 기준 검색 -->
            <input v-if="['deviceid', 'devicename'].includes(searchType)" type="text" v-model="searchQuery" :placeholder="searchTypeList.find(type => type.name === searchType).placeholder" @input="searchQuery = $event.target.value" @compositionend="searchQuery = $event.target.value" />
            <!-- 그룹 기준 검색 -->
            <select v-if="searchType === 'groupname'" v-model="selectedGroup">
              <option v-for="group in group_list" :key="group.group_id" :value="group.group_id" :label="group.group_name"></option>
            </select>
            <!-- GeoFence 기준 검색 -->
            <select v-if="searchType === 'geofence'" v-model="selectedGeoFence">
              <option v-for="geofence in nowGeoList" :key="geofence.geofence_id" :value="geofence.geofence_id" :label="geofence.geofence_name"></option>
            </select>
            <!-- 배터리 / 신호세기 기준 검색 -->
            <div v-if="['battery'].includes(searchType)" style="width: 100%;">
              <DualSlider
                :min=setRange[0]
                :max=setRange[1]
                :tickInterval=25 />
            </div>
            <div v-if="['rsrp'].includes(searchType)" style="width: 100%;">
              <DualSlider
                :min=setRange[0]
                :max=setRange[1]
                :tickInterval=20 />
            </div>
            <!-- 마지막 연결 시간 기준 검색 -->
            <div v-if="searchType === 'lastuptime'" style="display: flex; flex-direction: row;">
              <input type="number" v-model="searchHour" min="0" placeholder="시">
              <span style="padding: 10px; padding-left: 5px; padding-right: 5px;">:</span>
              <input type="number" v-model="searchMinute" min="0" placeholder="분">
              <span style="padding: 10px; padding-left: 5px; padding-right: 5px;">:</span>
              <input type="number" v-model="searchSecond" min="0" placeholder="초">
            </div>
          </div>
          <input type="text" v-model="searchQueryNB" :placeholder="'5G CPE 검색'" v-if="showMobileOrNB === 1"/>
          <input type="text" v-model="searchQueryNB" :placeholder="'5G DU/RU 검색'" v-if="showMobileOrNB === 2"/>
          <input type="text" v-model="searchQueryNB" :placeholder="'4G DU/RU 검색'" v-if="showMobileOrNB === 3"/>
        </div>

        <div class="main-body-device-status" v-if="showMobileOrNB === 0">
          <div style="display: flex;
                      justify-content: space-between;
                      align-items: center;
                      text-align: left;
                      width: 100%;">
            <h1 style="display: flex; flex-direction: column;">
              {{ $t('device_status_info') }}<br>
              <span>Device Status Information</span>
            </h1>
            <!-- 토글 버튼 -->
            <div class="tab-bar-container" @click="isToggleOn = !isToggleOn">
              <!-- 슬라이딩 배경 -->
              <div class="tab-slider" :class="{ right: isToggleOn }"></div>

              <!-- 텍스트 탭 -->
              <div class="tab-bar" :style="!isToggleOn ? { color: '#FFFFFF' } : {}">{{ $t('manage_device') }}</div>
              <div class="tab-bar" :style="isToggleOn ? { color: '#FFFFFF' } : {}">{{ $t('show_path') }}</div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; width: 100%; height: 27px; font-weight: 700; font-style: Bold; font-size: 14px; line-height: 27px; letter-spacing: 0%; color: #424D63; margin: -10px 0;">
            <div>
              연결 {{ state.locations.filter(l => get_lastupdate_time(l.timestamp) < MAX_TIME).length }}대 / 미연결 {{ state.locations.filter(l => get_lastupdate_time(l.timestamp) >= MAX_TIME).length }}대
            </div>
            <div v-if="searchType === 'geofence'">
              IN {{ state.locations.length }}대 / OUT {{ state.allLocations.length - state.locations.length }}대
            </div>
          </div>
          <div class="device-status-list">
            <div class="device-status-box" v-for="device in sortedData_locations"
              :key="device.device_id"
              :id="'device-' + device.device_id"
              @click="isToggleOn ? showDeviceSimple(device, 'Path') : showDeviceSimple(device, 'DeviceSimple');"
              @mouseover="highlightMarker(device.device_id)"
              @mouseleave="resetMarkerHighlight(device.device_id)"
              style="cursor: pointer;">
              <header class="device-status-header">
                <img :src="getDeviceImage(device.device_id)" style="height: 22px; width: 22px; margin: 0; margin-right: -5px; align-items: center;" />
                <div class="device-status-header-left">
                  <h3 style="margin-bottom: -5px;" :title="device.device_name">{{ device.device_name }}</h3>
                  <h4 :title="device.device_id">{{ device.device_id }}</h4>
                </div>
                <div class="device-status-header-right" :style="true ? {} : { backgroundColor: getColorByStatus(device.timestamp) }" style="width: 65px; white-space: nowrap;">
                  <h5>{{ get_lastupdate_time(device.timestamp) }} 초 전</h5>
                  <div class="device-status-body">
                    <img :src="signalImage(device.lte_rsrp)" />
                    <!-- <h2 style="width: 47px;">{{ device.lte_rsrp }} dBm</h2> -->

                    <img :src="batteryImage(device.battery_level)" />
                    <!-- <h2 style="width: 30px;">{{ device.battery_level }} %</h2> -->

                    <img :src="speedImage(device.speed)" />
                    <h2 style="width: 45px;">{{ Math.round(device.speed) ?? 0 }} km/h</h2>
                  </div>
                </div>
              </header>
              
            </div>
          </div>
        </div>

        <div class="main-body-device-status" v-if="showMobileOrNB === 1">
          <div style="display: flex;
                      align-items: center;
                      justify-content: center;
                      text-align: left;
                      width: 100%;">
            <h1 style="display: flex; flex-direction: column;">
              5G CPE 상태 정보<br>
              <span>5G CPE Status Information</span>
            </h1>
          </div>
          <div style="height: 27px; font-weight: 700; font-style: Bold; font-size: 14px; line-height: 27px; letter-spacing: 0%; color: #424D63; margin: -10px 0;">
            연결 {{ counterCPEOn }}대 / 미연결 {{ counterCPEOff }}대
          </div>
          <div class="device-status-list" v-if="filteredCPE">
            <div class="device-status-box" v-for="ue in filteredCPE"
              :key="ue.imsi"
              :id="'ue-' + ue.imsi"
              @click="clickCPEMarker(ue.imsi)"
              @mouseover="highlightCPE(ue.imsi)"
              @mouseleave="resetnbCPEHighlight(ue.imsi)"
              style="cursor: pointer;">
              <header class="device-status-header">
                <img :src="ue.state !== 'OFF' ? require('@/assets/images/simsys/circle_5gcpe_green.svg') : require('@/assets/images/simsys/circle_5gcpe_gray.svg')" style="height: 22px; width: 22px; margin: 0; margin-right: -5px; align-items: center;" />
                <div class="device-status-header-left">
                  <h3 style="margin-bottom: -5px;" :title="ue.imsi">{{ ue.imsi }}</h3>
                  <h4 :title="ue.msisdn">{{ ue.msisdn }}</h4>
                </div>
                <div class="device-status-header-right" style="width: 65px; white-space: nowrap; text-align: right;">
                  <h5>{{ cpeLastUpdateTime(ue) }} 초 전</h5>
                  <div class="device-status-body" style="padding-right: 0; padding-top: 5px; gap: 10px;">
                    <h2 style="">State: {{ ue.state }}</h2>
                    <h2 style="">NB IP: {{ ue.nb_ip }}</h2>
                  </div>
                </div>
              </header>
            </div>
          </div>
        </div>

        <div class="main-body-device-status" v-if="showMobileOrNB === 2">
          <div style="display: flex;
                      align-items: center;
                      justify-content: center;
                      text-align: center;
                      width: 100%;">
            <h1 style="display: flex; flex-direction: column;">
              5G DU/RU 상태 정보<br>
              <span>5G DU/RU Status Information</span>
            </h1>
          </div>
          <div style="height: 27px; font-weight: 700; font-style: Bold; font-size: 14px; line-height: 27px; letter-spacing: 0%; color: #424D63; margin: -10px 0;">
            연결 {{ counterGNBOn }}대 / 미연결 {{ counterGNBOff }}대
          </div>
          <div class="device-status-list" v-if="filteredNB">
            <div class="device-status-box" v-for="nb in filteredNB.filter(nb => nb.latest_service_state_info?.nb === 'GNB')"
              :key="nb.nb_id"
              :id="'nb-' + nb.nb_id.replace('/\//g', '\\/')"
              @click="clickNBMarker(nb.nb_id)"
              @mouseover="highlightNB(nb.nb_id)"
              @mouseleave="resetNBHighlight(nb.nb_id)"
              style="cursor: pointer;">
              <header class="device-status-header">
                <img :src="nb.latest_service_state_info?.bb_state === 'INS' && nb.latest_service_state_info?.CELL1_STATE === 'INS' && nb.latest_service_state_info?.epc_state !== 'OFF' ? require('@/assets/images/simsys/circle_5gru_green.svg') : require('@/assets/images/simsys/circle_5gru_gray.svg')" style="height: 22px; width: 22px; margin: 0; margin-right: -5px; align-items: center;" />
                <div class="device-status-header-left">
                  <h3 style="margin-bottom: -5px;" :title="nb.latest_lan_info?.ip_address">{{ nb.latest_lan_info?.ip_address }}</h3>
                  <h4 :title="nb.nb_id">{{ nb.nb_id }}</h4>
                </div>
                <div class="device-status-header-right" style="width: 65px; white-space: nowrap; text-align: right;">
                  <h5>{{ nbLastUpdateTime(nb) }} 초 전</h5>
                  <div class="device-status-body" style="padding-right: 0; padding-top: 5px; gap: 10px;">
                    <h2 style="">BB State: {{ nb.latest_service_state_info?.bb_state }}</h2>
                    <h2 style="">Cell State: {{ nb.latest_service_state_info?.CELL1_STATE }}</h2>
                    <h2 style="">Core State: {{ nb.latest_service_state_info?.epc_state }}</h2>
                  </div>
                </div>
              </header>
            </div>
          </div>
        </div>

        <div class="main-body-device-status" v-if="showMobileOrNB === 3">
          <div style="display: flex;
                      align-items: center;
                      justify-content: center;
                      text-align: center;
                      width: 100%;">
            <h1 style="display: flex; flex-direction: column;">
              4G DU/RU 상태 정보<br>
              <span>4G DU/RU Status Information</span>
            </h1>
          </div>
          <div style="height: 27px; font-weight: 700; font-style: Bold; font-size: 14px; line-height: 27px; letter-spacing: 0%; color: #424D63; margin: -10px 0;">
            연결 {{ counterENBOn }}대 / 미연결 {{ counterENBOff }}대
          </div>
          <div class="device-status-list" v-if="filteredNB">
            <div class="device-status-box" v-for="nb in filteredNB.filter(nb => nb.latest_service_state_info?.nb === 'ENB')"
              :key="nb.nb_id"
              :id="'nb-' + nb.nb_id.replace('/\//g', '\\/')"
              @click="clickNBMarker(nb.nb_id)"
              @mouseover="highlightNB(nb.nb_id)"
              @mouseleave="resetNBHighlight(nb.nb_id)"
              style="cursor: pointer;">
              <header class="device-status-header">
                <img :src="nb.latest_service_state_info?.bb_state === 'INS' && nb.latest_service_state_info?.CELL1_STATE === 'INS' && nb.latest_service_state_info?.epc_state !== 'OFF' ? require('@/assets/images/simsys/circle_4gru_green.svg') : require('@/assets/images/simsys/circle_4gru_gray.svg')" style="height: 22px; width: 22px; margin: 0; margin-right: -5px; align-items: center;" />
                <div class="device-status-header-left">
                  <h3 style="margin-bottom: -5px;" :title="nb.latest_lan_info?.ip_address">{{ nb.latest_lan_info?.ip_address }}</h3>
                  <h4 :title="nb.nb_id">{{ nb.nb_id }}</h4>
                </div>
                <div class="device-status-header-right" style="width: 65px; white-space: nowrap; text-align: right;">
                  <h5>{{ nbLastUpdateTime(nb) }} 초 전</h5>
                  <div class="device-status-body" style="padding-right: 0; padding-top: 5px; gap: 10px;">
                    <h2 style="">BB State: {{ nb.latest_service_state_info?.bb_state }}</h2>
                    <h2 style="">Cell State: {{ nb.latest_service_state_info?.CELL1_STATE }}</h2>
                    <h2 style="">Core State: {{ nb.latest_service_state_info?.epc_state }}</h2>
                  </div>
                </div>
              </header>
            </div>
          </div>
        </div>
      </div>

      <!-- 토글 버튼 -->
      <div style="background-color: transparent; height: 100%; z-index: 500; margin-right: -60px;">
        <button class="toggle-button" :class="['toggle-button', { open: isRightPanelOpen }]" ref="toggleBtn" @click="togglePanel">
          <img v-if="isRightPanelOpen" src="@/assets/images/arrow_left_gray.svg" />
          <img v-else src="@/assets/images/arrow_right_gray.svg" />
        </button>
      </div>

      <div class="main-body-left">
        <div class="main-body-map">
          <!-- #region 지도 -->
          <div id="map" style="height: 100%; width: 100%;">
            <div class="map-button-gruop-state">
              <!-- <button style="border-radius: 16px; border: none; cursor: pointer; padding: 0 10px;" :style="showMobileOrNB ? {backgroundColor: '#3E4C67', color: '#FFFFFF'} : {backgroundColor: '#EEEEEE', color: '#424D63'}" @click="showMobileOrNB = !showMobileOrNB">{{ showMobileOrNB ? '기지국 보기' : '단말기 보기'}}</button> -->
              <button @click.stop="showMobileOrNB = 0" :disabled="showMobileOrNB === 0">
                <img v-if="showMobileOrNB === 0" src="@/assets/images/simsys/button_mobile_active.svg"/>
                <img v-else src="@/assets/images/simsys/button_mobile.svg"/>
                단말기
              </button>
              <button @click.stop="showMobileOrNB = 1" :disabled="showMobileOrNB === 1">
                <img v-if="showMobileOrNB === 1" src="@/assets/images/simsys/button_cpe_active.svg"/>
                <img v-else src="@/assets/images/simsys/button_cpe.svg"/>
                5G CPE
              </button>
              <button @click.stop="showMobileOrNB = 2" :disabled="showMobileOrNB === 2">
                <img v-if="showMobileOrNB === 2" src="@/assets/images/simsys/button_gnb_active.svg"/>
                <img v-else src="@/assets/images/simsys/button_gnb.svg"/>
                5G DU/RU
              </button>
              <button @click.stop="showMobileOrNB = 3" :disabled="showMobileOrNB === 3">
                <img v-if="showMobileOrNB === 3" src="@/assets/images/simsys/button_enb_active.svg"/>
                <img v-else src="@/assets/images/simsys/button_enb.svg"/>
                4G DU/RU</button>
            </div>
            <div class="map-button-gruop">
              <button :title="$t('menu')" @click.stop="isMenuModalOpen = true" style="width: 56px; height: 56px; padding: 0;"><img src="@/assets/images/setting.svg" style="width: 30px;" /></button>
              <div class="map-button-gruop-zoom">
                <button @click.stop="state.map.zoomIn()" :disabled="state.map && nowZoomLevel === state.map.getMaxZoom()"><img src="../assets/images/new_plus_black.svg" /></button>
                <button style="cursor: default;" title="Zoom Level">{{ nowZoomLevel }}</button>
                <button @click.stop="state.map.zoomOut()" :disabled="state.map && nowZoomLevel === state.map.getMinZoom()"><img src="../assets/images/new_minuse_black.svg" /></button>
              </div>
              <button @click.stop="isMeasuring ? stopMeasuring(state.map) : totalDistance > 0 ? clearMeasuring(state.map) : startMeasuring()" style="background-color: #3E4C67; width: 56px; height: 56px;">
                <img :src="isMeasuring ? require('@/assets/images/new_ruler_red.svg') : totalDistance > 0 ? require('@/assets/images/broom-white.svg') : require('@/assets/images/new_ruler_white.svg')" />
              </button>
            </div>
            <div class="map-under-bar">
              <div>
                단말기
                <div>
                  <div>
                    <img src="../assets/images/simsys/green_circle.svg"/>
                    {{ state.locations.filter(l => get_lastupdate_time(l.timestamp) < MAX_TIME).length }}대
                  </div>
                  <div>
                    <img src="../assets/images/simsys/gray_circle.svg"/>
                    {{ state.locations.filter(l => get_lastupdate_time(l.timestamp) >= MAX_TIME).length }}대
                  </div>
                </div>
              </div>
              <div class="v-line"></div>
              <div>
                5G CPE
                <div>
                  <div>
                    <img src="../assets/images/simsys/green_circle.svg"/>
                    {{ counterCPEOn }}대
                  </div>
                  <div>
                    <img src="../assets/images/simsys/gray_circle.svg"/>
                    {{ counterCPEOff }}대
                  </div>
                </div>
              </div>
              <div class="v-line"></div>
              <div>
                5G DU/RU
                <div>
                  <div>
                    <img src="../assets/images/simsys/green_circle.svg"/>
                    {{ counterGNBOn }}대
                  </div>
                  <div>
                    <img src="../assets/images/simsys/gray_circle.svg"/>
                    {{ counterGNBOff }}대
                  </div>
                </div>
              </div>
              <div class="v-line"></div>
              <div>
                4G DU/RU
                <div>
                  <div>
                    <img src="../assets/images/simsys/green_circle.svg"/>
                    {{ counterENBOn }}대
                  </div>
                  <div>
                    <img src="../assets/images/simsys/gray_circle.svg"/>
                    {{ counterENBOff }}대
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>



  <div class="main-container" v-else>
    <div class="mobile-body-top">
      <h1>단말기 상태 정보</h1>
      <div class="mobile-body-search">
        <div style="width: 140px;">
          <h2>검색 기준</h2>
          <select v-model="searchType">
            <option v-for="type in searchTypeList" :key="type.name" :value="type.name">{{ type.title }}</option>
          </select>
        </div>
        <div style="width: calc(100% - 140px);">
          <h2>{{ searchTypeList.find(type => type.name === searchType).inputboxtag }}</h2>
          <!-- 장치ID / 장치이름 기준 검색 -->
          <input v-if="['deviceid', 'devicename'].includes(searchType)" type="text" v-model="searchQuery" :placeholder="searchTypeList.find(type => type.name === searchType).placeholder" />
          <!-- 그룹 기준 검색 -->
          <select v-if="searchType === 'groupname'" v-model="selectedGroup">
            <option v-for="group in group_list" :key="group.group_id" :value="group.group_id" :label="group.group_name"></option>
          </select>
          <!-- GeoFence 기준 검색 -->
          <select v-if="searchType === 'geofence'" v-model="selectedGeoFence">
            <option v-for="geofence in nowGeoList" :key="geofence.geofence_id" :value="geofence.geofence_id" :label="geofence.geofence_name"></option>
          </select>
          <!-- 배터리 / 신호세기 기준 검색 -->
          <div v-if="['battery'].includes(searchType)" style="width: 100%;">
            <DualSlider
              :min=setRange[0]
              :max=setRange[1]
              :tickInterval=25 />
          </div>
          <div v-if="['rsrp'].includes(searchType)" style="width: 100%;">
            <DualSlider
              :min=setRange[0]
              :max=setRange[1]
              :tickInterval=20 />
          </div>
          <!-- 마지막 연결 시간 기준 검색 -->
          <div v-if="searchType === 'lastuptime'" style="display: flex; flex-direction: row;">
            <input type="number" v-model="searchHour" min="0" placeholder="시">
            <span style="padding: 10px; padding-left: 5px; padding-right: 5px;">:</span>
            <input type="number" v-model="searchMinute" min="0" placeholder="분">
            <span style="padding: 10px; padding-left: 5px; padding-right: 5px;">:</span>
            <input type="number" v-model="searchSecond" min="0" placeholder="초">
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-body-map" :class="['mobile-body-map', { open: isRightPanelOpen }]">
      <!-- #region 지도 -->
      <div id="map" style="height: 100%; width: 100%;"></div>
    </div>

    <div class="mobile-device-status" :class="['mobile-device-status', { open: isRightPanelOpen }]">
      <button class="mobile-toggle-button" ref="toggleBtn" @click="togglePanel">
        <img v-if="isRightPanelOpen" src="@/assets/images/new_arrow_down_darkgray.svg" />
        <img v-else src="@/assets/images/new_arrow_up_darkgray.svg" />
      </button>
      <div style="display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;">
        <!-- 토글 버튼 -->
        <div class="mobile-tab-bar-container" @click="isToggleOn = !isToggleOn">
          <!-- 슬라이딩 배경 -->
          <div class="mobile-tab-slider" :class="{ right: isToggleOn }"></div>
          
          <!-- 텍스트 탭 -->
          <div class="mobile-tab-bar">{{ $t('manage_device') }}</div>
          <div class="mobile-tab-bar">{{ $t('show_path') }}</div>
        </div>
      </div>
      <h1 style="display: flex; flex-direction: column;">
        전체 리스트
      </h1>
      <div class="device-status-list">
        <div class="device-status-box" v-for="device in sortedData_locations"
          :key="device.device_id"
          :id="'device-' + device.device_id"
          @click="isToggleOn ? showDeviceSimple(device, 'Path') : showDeviceSimple(device, 'DeviceSimple');"
          @mouseover="highlightMarker(device.device_id)"
          @mouseleave="resetMarkerHighlight(device.device_id)"
          style="cursor: pointer;">
          <header class="mobile-device-status-header">
            <img :src="getDeviceImage(device.device_id)" style="height: 20px; width: 20px; margin: 0; margin-right: -5px; align-items: center;" />
            <div class="mobile-device-status-header-left">
              <h3 style="margin-bottom: -5px;" :title="device.device_name">{{ device.device_name }}</h3>
              <h4 :title="device.device_id">{{ device.device_id }}</h4>
            </div>
            <div class="mobile-device-status-header-right" :style="true ? {} : { backgroundColor: getColorByStatus(device.timestamp) }" style="width: 65px; white-space: nowrap;">
              <h5>{{ get_lastupdate_time(device.timestamp) }} 초 전</h5>
            </div>
          </header>
          <main class="mobile-device-status-body">
            <img :src="signalImage(device.lte_rsrp)" />
            <h2 style="width: 45px;">{{ device.lte_rsrp }} dBm</h2>

            <img :src="batteryImage(device.battery_level)" />
            <h2 style="width: 30px;">{{ device.battery_level }} %</h2>

            <img :src="speedImage(device.speed)" />
            <h2 style="width: 60px;">{{ device.speed ?? 0 }} km/h</h2>
          </main>
        </div>
      </div>
    </div>
  </div>

  <!-- 알림 컴포넌트 -->
  <NotificationPopup />

  <!-- 우클릭 메뉴 -->
  <ContextMenu />

  <!-- 마우스 호버 시 정보 표시 -->
  <MouseHoverTip />

  <MenuModal v-if="isMenuModalOpen" />
  <DeviceModalSimple v-if="isDeviceModalSimpleOpen" />
  <PathModal v-if="isPathModalOpen" />
  <POIModalSimple v-if="isPOIModalSimpleOpen" />
</template>

<script setup>
//#region import
import { ref, onMounted, nextTick, watch, onUnmounted, computed } from 'vue';

// 유틸리티 및 설정
import { geofence_list, GET_SERVER_REQUEST, group_list, socket } from '@/utils/ServerConnect';
import { defaultLocation, defaultZoomLevel, deviceGroupRange, drawPolygon, fetchCustomMarker, firstMapSetting, setBaseStationMarker, getMarkerGroupingRange, highlightMarker, isPOIModalSimpleOpen, polygonLayer, resetMarkerHighlight, highlightNB, resetNBHighlight, clickNBMarker, searchQueryNB, filteredNB, clickCPEMarker, showOneGF, filteredCPE, highlightCPE, resetnbCPEHighlight } from '@/utils/MapSetting';
import { SendErrorLog, getIsMobile, get_lastupdate_time, handleKeyboard, hasError, nbLastUpdateTime, cpeLastUpdateTime, setIsMoblie } from '@/utils/GlobalUtility';

// 컴포넌트 (공통)
import NotificationPopup from "@/components/NotificationPopup.vue";
import ContextMenu from '@/components/ContextMenu.vue';
import UserStatusBar from '@/components/UserStatusBar.vue';
import MouseHoverTip from '@/components/MouseHoverTip.vue';
import { addPoint, clearMeasuring, handleMouseMove, isMeasuring, measuringLocations, startMeasuring, stopMeasuring, tempLine, tempTooltip, totalDistance } from '@/utils/DistanceMeasuring';
import { MAX_TIME, searchHour, searchMinute, searchQuery, searchSecond, searchType, searchTypeList, selectedGeoFence, selectedGroup, setRange, state } from '@/utils/SearchDevice';
import { handleMapContextMenu } from '@/utils/MenuUtility';
import { filterObjects, sortedData_locations } from '@/utils/SortUtility';
import { isDeviceModalSimpleOpen, isMenuModalOpen, isPathModalOpen, isToggleOn, showDeviceSimple } from '@/utils/ModalUtility';
import { showNotification } from '@/utils/Notification';
import DualSlider from '@/components/DualSlider.vue';
import DeviceModalSimple from '@/modals/DeviceModalSimple.vue';
import PathModal from '@/modals/PathModal.vue';
import { fetchDeviceImages, getDeviceImage } from '@/utils/ImageUtility';
import POIModalSimple from '@/modals/POIModalSimple.vue';
import { Get_Setting } from '@/utils/Setting';
import { loadingStore } from '@/utils/LoadingStore';
import MenuModal from '@/modals/MenuModal.vue';
import { getColorByStatus } from '@/utils/ColorUtility';
//#endregion

const nowZoomLevel = ref(defaultZoomLevel.value);

const toggleBtn = ref(null);
const isRightPanelOpen = ref(true);
const togglePanel = async () => {
  isRightPanelOpen.value = !isRightPanelOpen.value; // 패널 열림 상태 토글

  await nextTick();
  // 애니메이션과 함께 지도 크기 재조정 (지연 시간 추가)
  setTimeout(() => {
    state.map?.invalidateSize(); // 지도 크기를 다시 계산
  }, 350); // CSS transition 시간과 맞춤 (0.3s + 약간의 버퍼)
};
const showMobileOrNB = ref(0); // 단말기 상태 정보 / 기지국 상태 정보 전환

const toggleBtnTitle = ref(null);
const isTitlePanelOpen = ref(false);
const togglePanelTitle = async () => {
  isTitlePanelOpen.value = !isTitlePanelOpen.value;
  await nextTick();
  // 애니메이션과 함께 지도 크기 재조정 (지연 시간 추가)
  setTimeout(() => {
    state.map?.invalidateSize(); // 지도 크기를 다시 계산
  }, 350); // CSS transition 시간과 맞춤 (0.3s + 약간의 버퍼)
}

//#region 위치정보(마커, 폴리곤 등) 표시 관련
const nowGeoList = ref(null);
// API를 통해 위치정보 받아오기
const fetchLocationData = async (locations, geofences) => {
  try {
    // 폴리곤 초기화
    if (polygonLayer.value) {
      polygonLayer.value.forEach(layer => state.map.removeLayer(layer)); // 기존 폴리곤이 있다면 삭제
      polygonLayer.value = [];
    }
    
    nowGeoList.value = geofences;
    state.polygons = geofences ? geofences : {};

    // 만약 검색조건으로 Geo Fence 검색시 해당 Geo Fence 만 보여줌
    if (selectedGeoFence.value) {
      state.polygons = state.polygons.filter(poly => poly.geofence_id === selectedGeoFence.value);
    }

    // 위치정보 저장 및 표시(updateMarksers 포함됨) (검색중이면 검색데이터만)
    filterObjects(locations);

    if (state.polygons) {
      state.polygons.forEach(poly => drawPolygon(poly));
    }

  } catch (error) {
    SendErrorLog('Web', error);
  }
};
//#endregion

//#region onMounted (최초 실행 시 설정 부분)
// Initialize map on component mount
onMounted(async () => {
  loadingStore.showLoading();
  try {
    nextTick(async () => {
      geofence_list.value = await GET_SERVER_REQUEST('geofence');

      if (!document.getElementById('map')) throw new Error('Map container not found');  // 지도 표시 실패시 오류 띄워버리기기
      state.map = await firstMapSetting();  // 지도 생성
      state.map?.invalidateSize(); // 지도 크기를 다시 계산
      let isZooming = false; // 줌 상태 관리 플래그

      // 측위 기능
      state.map.on("click", (e) => {
        if (isMeasuring.value) {
          addPoint(e.latlng, state.map);
        }
      });
      state.map.on("mousemove", (e) => {
        if (isZooming) return;
        handleMouseMove(e, state.map);
      });
      state.map.on("contextmenu", (event) => {
        if (isMeasuring.value) stopMeasuring(state.map);
        if (event.originalEvent.target.tagName === 'IMG') return; // 마커가 우클릭된 경우 맵 메뉴 무시
        handleMapContextMenu(event);
      });
      state.map.on("zoom", () => {
        if (tempLine.value && state.map.hasLayer(tempLine.value) && measuringLocations.value) {
          tempLine.value.setLatLngs([
            measuringLocations.value[measuringLocations.value.length - 1],
            state.map.getCenter(),
          ]);
        }
        if (tempTooltip.value && state.map.hasLayer(tempTooltip.value)) {
          tempTooltip.value.setLatLng(state.map.getCenter());
        }
      });
      state.map.on("zoomend", () => {
        nowZoomLevel.value = state.map.getZoom();
        deviceGroupRange.value = getMarkerGroupingRange() * Math.pow(2, 18 - nowZoomLevel.value);
      });

      fetchDeviceImages(); // 장치 이미지 캐싱해두기
      fetchCustomMarker(); // 커스텀 마커 캐싱해두기
      
      socket.on("welcome", (noti) => {
        showNotification(noti.message, noti.state, 'bottom-right')
      })
      socket.on("updateLocations", (noti) => {
        fetchLocationData(noti.locations, noti.geofences);
      })
      socket.on("geofenceAlert", (noti) => {
        showNotification(noti.action, noti.state, 'bottom-right');
      })
      socket.on("updateNBState", (noti) => {
        setBaseStationMarker(noti);
      })

      window.addEventListener('keydown', handleKeyboard);

      setIsMoblie();
      window.addEventListener('resize', setIsMoblie);
    })
    setTimeout(() => {
      state.map?.invalidateSize(); // 지도 크기를 다시 계산
    }, 350); // CSS transition 시간과 맞춤 (0.3s + 약간의 버퍼)
  } catch (error) {
    SendErrorLog('Web', error);
  } finally {
    loadingStore.hideLoading();
  }
});
//#endregion
//#region onUnmounted (컴포넌트 언마운트 시)
onUnmounted(() => {
  // if (state.map) state.map.remove();
  window.removeEventListener('keydown', handleKeyboard);
  window.removeEventListener('resize', setIsMoblie);
});
//#endregion

const controlError = () => {
  if (hasError.value) {
    if (socket) {
      socket.off("welcome"); // "welcome" 이벤트 리스너 제거
      socket.off("geofenceAlert"); // "geofenceAlert" 이벤트 리스너 제거
      // socket.off("serverStatus"); // "serverStatus" 이벤트 리스너 제거
    }
    if (state.map) state.map.remove();
  }
};
watch(hasError, controlError);

//#region 로그아웃
// const router = useRouter();
// const logout = () => {
//   const session = JSON.parse(localStorage.getItem('session'));
//   SendErrorLog('C101', { name: 'Logout success',
//                          message: `Logout attempt id : ${session.loginid}`,
//                          stack: session.loginid,})
//   localStorage.removeItem('session');
//   showNotification('Logout success', 'alarm', 'top-center');
//   router.push({ name: 'LoginPage' });
// }
//#endregion

// 🖼️ 신호 세기에 따른 이미지 경로 반환
const signalImage = (rsrp) => {
  if (!rsrp) return new URL('../assets/images/new_cell_power3.svg', import.meta.url).href;
  if (rsrp >= -1) return new URL('../assets/images/new_cell_power3.svg', import.meta.url).href;
  if (rsrp >= -100) return new URL('../assets/images/new_cell_power1.svg', import.meta.url).href;
  if (rsrp >= -110) return new URL('../assets/images/new_cell_power2.svg', import.meta.url).href;
  return new URL('../assets/images/new_cell_power3.svg', import.meta.url).href;
};
// 🖼️ 배터리 잔량에 따른 이미지 경로 반환
const batteryImage = (batlevel) => {
  if (!batlevel) return new URL('../assets/images/new_battery3.svg', import.meta.url).href;
  if (batlevel >= Get_Setting('battery_level_range').high) return new URL('../assets/images/new_battery1.svg', import.meta.url).href;
  if (batlevel >= Get_Setting('battery_level_range').low) return new URL('../assets/images/new_battery2.svg', import.meta.url).href;
  return new URL('../assets/images/new_battery3.svg', import.meta.url).href;
};
// 🖼️ 속도에 따른 이미지 경로 반환
const speedImage = (speed) => {
  if (!speed) return new URL('../assets/images/new_speed3.svg', import.meta.url).href;
  if (speed >= 30) return new URL('../assets/images/new_speed1.svg', import.meta.url).href;
  if (speed >= 1) return new URL('../assets/images/new_speed2.svg', import.meta.url).href;
  return new URL('../assets/images/new_speed3.svg', import.meta.url).href;
};

window.addEventListener('resize', function() {
  state.map.invalidateSize();
});

watch(selectedGeoFence, () => {
  // console.log(geofence_list.value)
  const nowGF = geofence_list.value.find(geo => geo.geofence_id === selectedGeoFence.value);
  
  // 폴리곤 초기화
  if (polygonLayer.value) {
    polygonLayer.value.forEach(layer => state.map.removeLayer(layer)); // 기존 폴리곤이 있다면 삭제
    polygonLayer.value = [];
  }
  drawPolygon(nowGF);
  showOneGF(nowGF);
});

const counterCPEOn = computed(() => {
  if (!filteredCPE.value) return 0;
  return filteredCPE.value.filter(cpe => cpe.state !== 'OFF').length;
});
const counterCPEOff = computed(() => {
  if (!filteredCPE.value) return 0;
  return filteredCPE.value.filter(cpe => cpe.state === 'OFF').length;
});
const counterGNBOn = computed(() => {
  if (!filteredNB.value) return 0;
  return filteredNB.value.filter(nb => nb.latest_service_state_info?.nb === 'GNB').filter(nb => nb.latest_service_state_info.bb_state === "INS" && nb.latest_service_state_info.CELL1_STATE === "INS" && nb.latest_service_state_info?.epc_state !== "OFF").length;
});
const counterGNBOff = computed(() => {
  if (!filteredNB.value) return 0;
  return filteredNB.value.filter(nb => nb.latest_service_state_info?.nb === 'GNB').filter(nb => !(nb.latest_service_state_info.bb_state === "INS" && nb.latest_service_state_info.CELL1_STATE === "INS" && nb.latest_service_state_info?.epc_state !== "OFF")).length;
});
const counterENBOn = computed(() => {
  if (!filteredNB.value) return 0;
  return filteredNB.value.filter(nb => nb.latest_service_state_info?.nb === 'ENB').filter(nb => nb.latest_service_state_info.bb_state === "INS" && nb.latest_service_state_info.CELL1_STATE === "INS" && nb.latest_service_state_info?.epc_state !== "OFF").length;
});
const counterENBOff = computed(() => {
  if (!filteredNB.value) return 0;
  return filteredNB.value.filter(nb => nb.latest_service_state_info?.nb === 'ENB').filter(nb => !(nb.latest_service_state_info.bb_state === "INS" && nb.latest_service_state_info.CELL1_STATE === "INS" && nb.latest_service_state_info?.epc_state !== "OFF")).length;
});
</script>

<style>
.toggle-switch {
  position: relative;
  width: 90px;
  height: 30px;
  background: #ddd;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.2);
  font-weight: bold;
  font-size: 14px;
  color: #333;
  transition: background 0.3s ease, color 0.3s ease;
  overflow: hidden;
}
.toggle-switch span {
  flex: 1;
  text-align: right;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.toggle-switch::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  transition: left 0.3s ease, background 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

/* 활성화 상태 */
.tab-bar-container {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 30px;
  background-color: #EEEEEE;
  width: 164px;
  height: 35px;
  color: #424D63;
  /* padding: 4px; */
  overflow: hidden;
  cursor: pointer;
}
.tab-bar {
  flex: 1;
  z-index: 1; /* 슬라이더 위에 텍스트 오게 */
  text-align: center;
  font-size: 12px;
  line-height: 22.5px;
  letter-spacing: 0%;
  position: relative;
  transition: color 0.3s ease, font-weight 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 3.5px);
}
.tab-slider {
  position: absolute;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 4px);
  background-color: #3E4C67;
  border-radius: 29.85px;
  transition: left 0.3s ease;
  z-index: 0;
  box-shadow: #00000015;
}
.tab-slider.right {
  left: calc(50%); /* 절반 + padding */
}


/* 활성화 상태 */
.mobile-tab-bar-container {
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 30px;
  background-color: #EEEEEE;
  width: 100%;
  height: 36px;
  color: #424D63;
  /* padding: 4px; */
  overflow: hidden;
  cursor: pointer;
}
.mobile-tab-bar {
  flex: 1;
  z-index: 1; /* 슬라이더 위에 텍스트 오게 */
  text-align: center;
  font-size: 12px;
  line-height: 27px;
  letter-spacing: 0%;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease, font-weight 0.3s ease;

  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 3.5px);
}
.mobile-tab-slider {
  position: absolute;
  left: 4px;
  width: calc(50% - 5px);
  height: calc(100% - 4px);
  background-color: #FFFFFF;
  border-radius: 29.85px;
  transition: left 0.3s ease;
  z-index: 0;
  box-shadow: 1.43px 1.43px 4.3px #00000015;
}
.mobile-tab-slider.right {
  left: calc(50%); /* 절반 + padding */
}


</style>